import { Component, effect, inject, OnInit } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTab, MatTabGroup } from '@angular/material/tabs';

import { AccessService } from 'src/app/services/access.service';

import { GroupLinkComponent } from '../group-link/group-link.component';
import { HeaderComponent } from '../header/header.component';
import { TaskViewComponent } from '../task-view/task-view.component';
import { HomepageService } from 'src/app/services/homepage.service';
import { UserReplacePipe } from '../../pipes/user-replace.pipe';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-mysite',
  templateUrl: './mysite.component.html',
  styleUrls: ['./mysite.component.scss'],
  imports: [
    MatProgressSpinner,
    HeaderComponent,
    MatTabGroup,
    MatTab,
    TaskViewComponent,
    GroupLinkComponent,
    UserReplacePipe
  ]
})
export class MysiteComponent implements OnInit {
  private accessService = inject(AccessService);
  private homepageService = inject(HomepageService);
  userService = inject(UserService);

  loaded = false;
  loadedUser = false;
  content = '';

  constructor() {
    effect(() => {
      if (this.userService.userProfile().mail) this.loadedUser = true;
    });
  }

  ngOnInit() {
    this.homepageService.getHomepage().subscribe({
      next: (homepage) => {
        this.content = homepage.content;
        this.loaded = true;
      }
    });
  }

  hasGroupEditRights() {
    return this.accessService.isGpiaAuditor() || this.accessService.isGprmAuditor() || this.accessService.isAdmin();
  }
}
